import React from 'react'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'
import { FieldArray } from 'react-final-form-arrays'
import arrayMutators from 'final-form-arrays'
import { includes, xor } from 'lodash/fp'
import moment from 'moment'

import { flexBoxStyles } from '../../components/Flexbox'
import Button from '../../components/Button'
import DatePicker from '../../components/DatePicker/DatePicker'

import CloseIcon from '../../images/closeIcon.svg'

import CheckBox from '../../components/Checkbox'
import { stateLabels, states } from './constants'

const fieldWidth = 310

const normalizeValues = (values) => {
  if (values.states.includes('REQUEST')) {
    return { ...values, states: [...values.states, 'GENERATING'] }
  } else {
    return values
  }
}

const smallFieldWidth = 150

const LoginForm = ({ initialValues, onClose, onSubmit }) => (
  <Form
    initialValues={initialValues}
    mutators={{
      ...arrayMutators,
    }}
    onSubmit={(values) => onSubmit(normalizeValues(values))}
  >
    {({ handleSubmit, invalid, form }) => (
      <FormWrapper>
        <Header justify="space-between">
          Filtruj
          <CloseButton
            onClick={onClose}
            icon={CloseIcon}
            altTag=""
            color="plain"
            ariaLabel="Zamknij"
          />
        </Header>
        <FieldArray
          name="states"
          component={CheckboxGroup}
          options={states}
          placeholder="First Name"
        />
        <Field
          name="requestDateMin"
          component={DatePicker}
          width={smallFieldWidth}
          label="Data od"
          maxDate={moment()}
          popperPlacement="bottom-start"
        />
        <Field
          name="requestDateMax"
          component={DatePicker}
          width={smallFieldWidth}
          label="Data do"
          popperPlacement="bottom-end"
        />

        <StyledButton
          width={`${fieldWidth}px`}
          label="Filtruj"
          onClick={handleSubmit}
          disabled={invalid}
        />
        <StyledButton
          color="white"
          width={`${fieldWidth}px`}
          label="Reset"
          onClick={() => {
            form.reset()
            onSubmit({
              states: ['REQUEST', 'GENERATING', 'DONE', 'ERROR'],
            })
          }}
        />
      </FormWrapper>
    )}
  </Form>
)

const CheckboxGroup = ({ fields, options }) => {
  return (
    <>
      {options.map((option) => (
        <Field
          key={option}
          fields={fields}
          option={option}
          name="states"
          component={FieldCheckbox}
        />
      ))}
    </>
  )
}

const FieldCheckbox = ({
  option,
  fields,
  input: { value, onChange, onBlur, ...input },
}) => (
  <CheckBox
    label={stateLabels[option]}
    input={{
      value: includes(option, fields.value),
      onChange: () => onChange(xor([option], fields.value)),
    }}
  />
)

const Header = styled.header`
  width: 100%;
  ${flexBoxStyles}
`

const FormWrapper = styled.div`
  padding: 0 10px;
  display: grid;
  grid: repeat(4, 70px) repeat(2, 80px) / 1fr 1fr;
  grid-gap: 10px;
  overflow: hidden;
  align-items: center;
  justify-items: start;
  height: 100vh;
  > header {
    grid-column: 1 / 3;
  }

  > button {
    grid-column: 1 / 3;
  }

  > div {
    &:nth-child(2) {
      grid-column: 1 / 2;
    }
    &:nth-child(3) {
      grid-column: 2 / 3;
    }
    &:nth-child(4) {
      grid-column: 1 / 2;
    }
    &:nth-child(5) {
      margin-bottom: 0;
      grid-column: 1 / 2;
    }
    &:nth-child(6) {
      margin-bottom: 0;
      grid-column: 2 / 3;
    }
  }
`

const StyledButton = styled(Button)`
  opacity: ${(props) => (props.disabled ? '0.5' : '1')};
`

const CloseButton = styled(Button)`
  padding: 0;
  margin: 0;
  width: 32px;
  height: 32px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    position: static;
    margin-left: auto;
  }
`;

export default LoginForm
